import AOS from 'aos';
import 'magnific-popup';
import Events from './events';

jQuery( document ).ready(function($) {

    $('.mfp-inline').magnificPopup({});
    $('.mfp-menu-item a').magnificPopup({});

    function debounce(method, delay) {
        clearTimeout(method._tId);
        method._tId= setTimeout(function(){
            method();
        }, delay);
    }

    function handleScroll(){
        if ($(document).scrollTop() > 100){
            $('#header').addClass('dark');
        } else {
            $('#header').removeClass('dark');
        }
    }

    if ($('body').hasClass('page-template-homepage')){
        
        $('#header').removeClass('dark');
        $(window).on('scroll', function() {
            debounce(handleScroll, 100);
        });
    }

    $('.newsletter').on('submit', function(e) {
        e.preventDefault();
        const DATA = $(this).serialize();
    
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            dataType: 'json',
            data: DATA,
            xhrFields: {
                withCredentials: false,
            },
            success: function (data) {
                $('.inputs-wrap').html('<p class="newsletter-thanks">Thanks for signing up!</p>');
            },
            error: function (err) {
                console.log(err);
            }
        });
    });

    Events();

    $('.menu-toggle').on('click', function(){
        $('#header').toggleClass('open');
        $('.menu-toggle').toggleClass('open');
    })
    
    $('.block').each(function(){
        $(this).css('order', Math.floor(Math.random() * 20))
        let align = Math.floor(Math.random() * 3);
        if (align == 0){
            $(this).css('align-self', 'flex-start')
        }
        if (align == 1){
            $(this).css('align-self', 'center')
        }
        if (align == 2){
            $(this).css('align-self', 'flex-end')
        }
        if ($(this).hasClass('photo')){
            $(this).css('flex-basis', ((400 + (Math.random() * 400)))/16 +'rem' )
        }
        
        if ($(this).hasClass('video')){
            $(this).css('flex-basis', ((400 + (Math.random() * 400)))/16 +'rem' )
        }
    })
    
    setTimeout(function(){
        AOS.init({
            duration: 2000,
            delay: 50,
            easing: 'ease'
        });
    }, 100);
    window.addEventListener('load', AOS.refresh);

});